const parseCoordinates = (venue) => {
  if (
    venue?.lat === null
    || venue?.lat === undefined
    || venue?.lat === ''
    || venue?.lng === null
    || venue?.lng === undefined
    || venue?.lng === ''
  ) return null;

  const lat = Number(venue.lat);
  const lng = Number(venue.lng);
  if (
    !Number.isFinite(lat)
    || !Number.isFinite(lng)
    || lat < -90
    || lat > 90
    || lng < -180
    || lng > 180
  ) return null;
  return { lat, lng };
};

export const getVenueLocationUrl = (venue) => {
  const coordinates = parseCoordinates(venue);
  if (!coordinates) return null;
  const { lat, lng } = coordinates;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${lat},${lng}`)}`;
};

export const hasVenueCoordinates = (venue) => Boolean(parseCoordinates(venue));
